import React, { useEffect } from 'react'
import EyeMedClaimForm from '../../services/eyemed/claimForm/form/EyeMedClaimForm';
import EyefinityClaimForm from '../../services/eyefinity/claimForm/form/EyefinityClaimForm';
import { connect, useDispatch } from 'react-redux';
import { visionInsuranceClaimFormEdit, visionInsuranceClaimFormTemplateLoad } from '../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction';
import SpecteraClaimForm from '../../services/spectera/claimForm/form/SpecteraClaimForm';
import VersantClaimForm from '../../services/versant/claimForm/form/VersantClaimForm';


function RpaClaimForm(props) {
  const { order, visionInsuranceClaimFormTemplate, editing } = props
  const dispatch = useDispatch()
  const orderInsurance = order.orders_insurances_attributes?.find(
    (item) => item.id === editing?.orders_insurance_id,
  )
  const visionInsuranceService = orderInsurance?.vision_insurance_service?.service

  useEffect(() => {
    dispatch(visionInsuranceClaimFormTemplateLoad())
    if (visionInsuranceService === 'eyemed' || visionInsuranceService === 'eyefinity' || visionInsuranceService === 'spectera' || visionInsuranceService === 'versant') {
      dispatch(visionInsuranceClaimFormEdit({ activeTab: 'first', activeModule: '' }))
    } else {
      dispatch(visionInsuranceClaimFormEdit({ activeModule: 'first' }))
    }
  }, [])

  const getClaimFormTemplate = () => {
    return visionInsuranceClaimFormTemplate.find((item) => item.service === visionInsuranceService)
  }

  const claimFormTemplate = getClaimFormTemplate()

  switch (visionInsuranceService) {
    case 'eyemed':
      if (!claimFormTemplate?.config) return null
      return <EyeMedClaimForm claimFormTemplate={claimFormTemplate} />
    case 'eyefinity':
      return <EyefinityClaimForm claimFormTemplate={claimFormTemplate} />

    case "spectera":
      return <SpecteraClaimForm claimFormTemplate={claimFormTemplate} />

    case "versant":
      return <VersantClaimForm claimFormTemplate={getClaimFormTemplate()} />

    default:
      return ''
  }
}

const mapStateToProps = (state) => {
  const { order: { order }, visionInsuranceClaimForm: { visionInsuranceClaimFormTemplate, editing } } = state
  return {
    order,
    visionInsuranceClaimFormTemplate,
    editing,
  }
}

export default connect(mapStateToProps)(RpaClaimForm);